/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Startingtemperaturesecs4Inputs */



/**
* | output |
* | --- |
* | "ECS starting temperatures" |
*
* @param {Br_History_Key_Startingtemperaturesecs4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_startingtemperaturesecs4 = /** @type {((inputs?: Br_History_Key_Startingtemperaturesecs4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Startingtemperaturesecs4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ECS starting temperatures")
	return /** @type {LocalizedString} */ ("Températures de départ ECS")
});
export { br_history_key_startingtemperaturesecs4 as "br_history_key_startingTemperaturesECS" }